<template>
  <div class="second-order-reference-item">
    <ReferenceDetailsLabels :source="source" :doc-type="reference.doc_type" />

    <h4 v-if="!reference.unsubstantiated" class="second-order-title" @click.stop="$emit('titleClicked')">
      {{ title }}
    </h4>

    <div class="reference-details-wrapper" @click.stop>
      <ReferenceDetails :reference="reference" @preview="$emit('preview', $event)" />
    </div>
  </div>
</template>

<script>
import ReferenceDetails from '~/components/conversation/referencePanel/ReferenceDetails.vue';
import ReferenceDetailsLabels from '~/components/conversation/referencePanel/ReferenceDetailsLabels.vue';

export default {
  name: 'SecondOrderReferenceItem',
  components: { ReferenceDetails, ReferenceDetailsLabels },
  emits: ['titleClicked', 'preview'],
  props: {
    title: {
      type: String,
      default: '',
    },
    source: {
      type: Object,
      default: () => ({}),
    },
    reference: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang="scss">
.second-order-reference-item {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-2;

  .second-order-title {
    @include bb-medium-text-styles('md');
    line-height: $bb-spacing-5;
    color: $bb-neutral-1;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .reference-details-wrapper {
    font-size: 10px;
    @include bb-regular-text-styles('xs');
    overflow: hidden;
    color: $bb-neutral-1;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2; /* Number of lines before ellipsis */
    -webkit-box-orient: vertical;
    box-sizing: border-box;
  }
}
</style>
